import React, { useCallback, useEffect } from 'react';
import $i18n from 'panda-i18n';
import { useFusionTable, useSetState } from 'ahooks';
import {
  Box,
  Button,
  Field,
  Form,
  Input,
  Select,
  Table,
  Grid,
  DatePicker,
  Icon,
  Message,
  Dialog,
  Search,
  NumberPicker,
} from '@fpxfd/next';
import {
  VAS_OPERATE_PERIOD,
  VAS_TASK_PERIOD,
  VAS_SERVICE_TYPE,
  VAS_SERVICE_OPERATE,
  VAS_ORDER_TYPE,
  VAS_ORDER_SOUCE,
  VAS_ORDER,
  VAS_SERVICE_API,
  VAS_CHANGE_LABEL_FLAG,
  INBOUNDSERVICE,
} from '@/const';
import { breakLine, tranformRangeTime, vToLabel } from '@/utils';

import FpxPage from '@/components/FpxPage';
import FpxPagination from '@/components/FpxPagination';
import ActionArea from '@/components/ActionArea';
import ExportBtn from '@/components/ExportBtn';
import FpxTab from '@/components/FpxTab';
import FpxTable from '@/components/FpxTable';
import PageHeader from '@/components/PageHeader';

import { StatesProps, pageNumberProps, Record, PrintData, PrintDataParent, LabelParams } from './index.interface';
import {
  getPageList,
  BatchClaim,
  printOrder,
  getSkuPrintData,
  getWaitingForLabelApi,
  completeChangeLabelApi,
  getTabCount,
  batchPrintLabel,
  getAllGroups,
} from './index.services';
import styles from './index.module.scss';
import { Link } from 'ice';
import SearchSelect from '@/components/SearchSelect';
import dealFileUrl from '@/utils/dealFileUrl';
import FitScreenBox from '@/components/FitScreenBox';
import moment from 'moment';
import { doExport } from '@/components/ExportBtn/index.service';
import SelectTime from '@/components/SelectTime';
import ExportButton from '@/components/ExportBtn';
import OfflineExport from '@/components/OfflineExport';

const { Col, Row } = Grid;
const { RangePicker } = DatePicker;
const startDate = moment().subtract(2, 'months').format('YYYY-MM-DD 00:00:00');

const VASOrder = () => {
  const [states, setStates] = useSetState<StatesProps>({
    rowSelection: {
      onChange: (ids, records) => onRowChange(ids, records),
      selectedRowKeys: [],
      selectedRecords: [],
    },

    printBarCodevisible: false,
    originPrintList: [],
    nowPrintList: [],
    printSearchData: '',
    printRowSelection: {
      onChange: (ids, records) => onPrintRowChange(ids, records),
      selectedRowKeys: [],
      selectedRecords: [],
      getProps: (record, index) => {
        record.id = `print${index}`;
        return record;
      },
    },

    tabKey: 'all',
    tabCountType: {
      total: 0, // 全部,
      canceled: 0, // 取消
      deleted: 0, // 已删除
      exception: 0, // 异常
      draft: 0, // 草稿
      pending: 0, // 待处理
      processing: 0, // 处理中
      verifiable: 0, // 待核实
      completed: 0, // 已完成
      returnable: 0, // 已退回
    },
    showAdvancedSearch: false,
    waitingLabelCount: 0,
    claimLoading: false,
    currentClaim: undefined,
    skuSearchData: '',
    printLoading: false,
    defaultOrderTime: 'createTime',
    vastime: [],
    allgroup: [],
  });

  /**
   * TAB TYPE
   */
  const VAS_TASK_PERIOD_TAB = [
    {
      label: `${$i18n.get({ id: 'All.four_px', dm: '全部' })}(${states.tabCountType?.total})`,
      value: 'all',
    },

    {
      label: `${$i18n.get({ id: 'Pending.four_px', dm: '待处理' })}(${states.tabCountType?.pending})`,
      value: 'T',
    },

    {
      label: `${$i18n.get({ id: 'Processing.four_px', dm: '处理中' })}(${states.tabCountType?.processing})`,
      value: 'P',
    },

    {
      label: `${$i18n.get({ id: 'PendingConfirmation.four_px', dm: '待确认' })}(${states.tabCountType?.verifiable})`,
      value: 'V',
    },

    {
      label: `${$i18n.get({ id: 'Completed.four_px', dm: '已完成' })}(${states.tabCountType?.completed})`,
      value: 'C',
    },

    {
      label: `${$i18n.get({ id: 'Returned.four_px', dm: '已退回' })}(${states.tabCountType?.returnable})`,
      value: 'R',
    },

    {
      label: `${$i18n.get({ id: 'Canceled.four_px', dm: '已取消' })}(${states.tabCountType?.canceled})`,
      value: 'X',
    },
  ];

  // table选择变化
  const onRowChange = useCallback(
    (ids, records) => {
      const { rowSelection } = states;
      rowSelection.selectedRowKeys = ids;
      rowSelection.selectedRecords = records;
      setStates({ rowSelection });
    },
    [setStates, states],
  );

  // 清空table选中数据
  const clearSelectedTable = useCallback(() => {
    const { rowSelection } = states;
    rowSelection.selectedRowKeys = [];
    rowSelection.selectedRecords = [];
    setStates({
      rowSelection,
    });
  }, [setStates, states]);

  // 清空打印选中数据
  const clearSelectedTablePrint = useCallback(() => {
    const { printRowSelection } = states;
    printRowSelection.selectedRowKeys = [];
    printRowSelection.selectedRecords = [];
    setStates({
      printRowSelection,
    });
  }, [setStates, states]);

  const transform = useCallback(
    (form: Record) => {
      const data = tranformRangeTime('times', ['beginTime', 'endTime'], form, 'YYYY-MM-DD HH:mm:ss');
      const newDatas = {
        ...data,
        status: states.tabKey,
      };

      const arr = ['consignmentNos', 'refNoList', 'inboundOrderList', 'outboundNos', 'inboundNos'];
      for (let i = 0; i < arr.length; i++) {
        const k = arr[i];
        if (newDatas[k]) {
          newDatas[k] = breakLine(newDatas[k]);
        } else delete newDatas[k];
      }
      const delArr = ['operationSegment', 'serviceType', 'dataSource', 'status'];
      delArr.forEach((e) => {
        newDatas[e] === 'all' && delete newDatas[e];
      });
      newDatas.input && delete newDatas.input;

      console.log(states.printRowSelection);
      return newDatas;
    },
    [states.tabKey],
  );

  const getTableData = ({ current, pageSize }: pageNumberProps, form: Record) => {
    const _params = {
      data: transform(form),
      pageObj: {
        current,
        pageSize,
      },
    };

    /**
     * 获取tab count数
     */
    const tabParams = JSON.parse(JSON.stringify(_params));
    tabParams.data.status && delete tabParams.data.status;
    getTabCount(tabParams).then((res) => {
      const tabCountType = { ...res };
      setStates({
        tabCountType,
      });
    });

    /**
     * 获取待换标数量
     */
    getWaitingForLabelApi(_params).then((res) => {
      setStates({
        waitingLabelCount: res || 0,
      });
    });
    return getPageList(_params);
  };

  const field = Field.useField();
  const { paginationProps, tableProps, search, loading, pagination } = useFusionTable(getTableData, {
    field,
    defaultPageSize: 20,
    debounceInterval: 500,
  });

  const { submit, reset } = search;

  const doSubmit = useCallback(() => {
    submit();
    clearSelectedTable();
  }, [clearSelectedTable, submit]);

  const doReset = () => {
    reset();
    clearSelectedTable();
  };

  // 页签操作
  const gettab = (e: string | number) => {
    setStates({
      tabKey: e,
    });

    clearSelectedTable();
    submit();
  };

  // 跳转至详情页
  const gotoDetail = (value: string, index: number, record) => {
    return (
      <Link to={{ pathname: `/order/vasorderdetail/${value}?sortType=${record?.serviceType}` }} target={'_blank'}>
        {value}
      </Link>
    );
  };

  /**
   * 完成换标
   */
  const completeChangeLabelFn = useCallback((no: string) => {
    completeChangeLabelApi(no).then((res) => {
      Message.success(
        $i18n.get({ id: 'AfterTheStandardChangeIsCompleted_1105740277', dm: '换标完成，开始用原容器进行上架操作！' }),
      );
      submit();
    });
  }, []);

  // 批量认领
  const batchClaim = (consignmentNo: string | null = null, index: number | undefined = undefined) => {
    if (!states.rowSelection.selectedRowKeys.length && !consignmentNo) {
      return Message.notice($i18n.get({ id: 'SelectDataFirst.four_px', dm: '请先选择数据' }));
    }
    if (states.rowSelection.selectedRowKeys.length) {
      setStates({
        claimLoading: true,
      });
    } else {
      console.log(index);

      setStates({
        currentClaim: index,
      });
    }
    const data = consignmentNo ? [consignmentNo] : states.rowSelection.selectedRowKeys;
    BatchClaim(data)
      .then((res) => {
        Message.success(
          consignmentNo
            ? `${$i18n.get({ id: 'Claimed.four_px', dm: '认领成功' })}!`
            : $i18n.get({ id: 'BulkClaimSucceeded.four_px', dm: '批量认领成功！' }),
        );

        setStates({
          claimLoading: false,
          currentClaim: undefined,
        });

        submit();
        clearSelectedTable();
      })
      .catch(() => {
        setStates({
          currentClaim: undefined,
          claimLoading: false,
        });
      });
  };

  // 批量打印清单
  // 打印sku多选
  const onPrintRowChange = useCallback(
    (ids, records) => {
      if (records?.qty <= 0) {
        return Message.notice(
          $i18n.get({ id: 'TheNumberOfPrintsMustBe_2942372047.four_px', dm: '打印数量必须大于0！' }),
        );
      }
      const { printRowSelection } = states;
      printRowSelection.selectedRowKeys = ids;
      printRowSelection.selectedRecords = records;

      setStates({ printRowSelection });
    },
    [setStates, states],
  );

  // 处理搜索数据
  const dealSearchData = () => {
    return states.originPrintList.map((e: PrintData) => {
      return {
        label: e?.skuCode,
        value: e?.skuCode,
      };
    });
  };
  // 处理SKU ID搜索数据
  const delalSkuData = () => {
    return states.originPrintList.map((e: PrintData) => {
      return {
        label: e?.skuId,
        value: e?.skuId,
      };
    });
  };
  // 打印sku模糊搜索
  const onSearchChange = (name: string, value: string) => {
    setStates({
      [name]: value,
    });
  };

  // 查询
  const barCodeSearch = () => {
    const s: string = states.printSearchData || states.skuSearchData;
    const now = states.originPrintList.filter((e: PrintData) => e?.skuCode === states.printSearchData);
    const skunow = states.originPrintList.filter((e: PrintData) => e?.skuId === states.skuSearchData);
    const newlist = now.concat(skunow);
    // 1. 存在搜索值，且now不为空, clear
    // 2. 不存在搜索值
    clearSelectedTablePrint();
    setStates({
      nowPrintList: s ? newlist : states.originPrintList,
    });
  };

  const batchPrint = () => {
    if (!states.rowSelection.selectedRowKeys?.length) {
      return Message.notice($i18n.get({ id: 'SelectDataFirst.four_px', dm: '请先选择数据' }));
    } else {
      const _params: string[] = [];
      const _paramsMF4P: string[] = [];

      states.rowSelection.selectedRecords?.forEach((e: Record) => {
        if (e?.dataSource === 'MF4PL') {
          _paramsMF4P.push(e?.consignmentNo);
        } else {
          _params.push(e?.consignmentNo);
        }
      });
      _paramsMF4P?.length &&
        doExport(
          {
            url: `${VAS_SERVICE_API}/print/export`,
            data: [..._paramsMF4P],
            method: 'POST',
          },
          $i18n.get({ id: 'List.four_px', dm: '清单' }),
        );

      _params?.length &&
        batchPrintLabel({ consignmentNos: _params }).then((res) => {
          if (res?.length) {
            res?.forEach((e) => {
              if (e?.fileUrl) {
                window.open(dealFileUrl(e?.fileUrl));
              }
            });
          }
        });
    }
    // return true;
  };

  // 打印货品条码
  const batchPrintSku = () => {
    if (!states.rowSelection.selectedRowKeys.length) {
      return Message.notice($i18n.get({ id: 'SelectDataFirst.four_px', dm: '请先选择数据' }));
    }
    const data = states.rowSelection.selectedRowKeys;
    getSkuPrintData(data).then((res) => {
      // 获取sku数据
      const list: PrintData[] = [];
      res?.dataDTOS?.forEach((e: PrintDataParent) => {
        e?.valueAddedTaskSkuDTOList.forEach((m: PrintData) => {
          const ACTUAL_TYPE = ['UP', 'BP', 'OTOC'];
          const item: PrintData = {
            ...m,
            qty: (ACTUAL_TYPE.includes(e?.serviceType || '') ? m?.actualOperationQty : m?.operationQty) || 0,
            operationQty: ACTUAL_TYPE.includes(e?.serviceType || '') ? m?.actualOperationQty : m?.operationQty,
            parentCustomerCode: e?.customerCode || '',
            // skuCode: (ACTUAL_TYPE.includes(e?.serviceType || '') ? m?.actualSkuCode : m?.skuCode) || '',
            // skuId: (ACTUAL_TYPE.includes(e?.serviceType || '') ? m?.actualSkuId : m?.skuId) || '',
          };
          return list.push(item);
        });
      });
      setStates({
        originPrintList: list,
        nowPrintList: list,
      });
    });
    setStates({
      printBarCodevisible: true,
    });
  };

  // 打印数量设置
  const setNewPrintList = (value: number, index: number, record: Record) => {
    const list: PrintData[] = [...states.nowPrintList];
    list[index].qty = value;

    const origin = [...states.originPrintList].map((e: PrintData) => {
      const item = { ...e };
      if (e?.consignmentNo === record?.consignmentNo) {
        item.qty = value;
        return item;
      }
      return item;
    });

    setStates({
      originPrintList: origin,
      nowPrintList: list,
    });
  };

  // 标签打印
  const labelPrint = () => {
    if (!states.printRowSelection.selectedRecords?.length) {
      return Message.notice($i18n.get({ id: 'SelectDataFirst.four_px', dm: '请先选择数据' }));
    }
    const data = [...states.printRowSelection.selectedRecords];
    const outDatas = {
      printParamJsonStr: data.map((e: PrintData) => {
        const _item: PrintData = {
          skuId: e.actualSkuId ? e.actualSkuId : e?.skuId,
          skuCode: e.actualSkuCode ? e.actualSkuCode : e?.skuCode,
          skuName: e.actualSkuName ? e.actualSkuName : e?.skuName,
          customerCode: e?.parentCustomerCode || '',
          qty: e?.qty || e?.operationQty || 0,
          remark: '',
          printType: 'LB',
        };
        _item.parentCustomerCode && delete _item.parentCustomerCode;
        return _item;
      }),
      printLabelType: 'SKU_LABEL',
    };
    setStates({ printLoading: true });
    printOrder(outDatas)
      .then((url) => {
        clearSelectedTable();
        url ? window.open(dealFileUrl(url)) : Message.notice($i18n.get({ id: 'PrintFailed.four_px', dm: '打印失败' }));
      })
      .finally(() => {
        setStates({ printLoading: false });
      });
  };

  const handlePrintCodeCancel = () => {
    clearSelectedTablePrint();
    setStates({
      printBarCodevisible: false,
      originPrintList: [],
      nowPrintList: [],
    });
  };

  /**
   * 渲染操作列
   */
  const renderActionColumn = useCallback(
    (value: number, index: number, record: Record) => {
      if (states.tabKey === 'T') {
        // 待处理
        return (
          <Button
            type="primary"
            text
            onClick={() => batchClaim(record?.consignmentNo, index)}
            loading={states.currentClaim === index}
            disabled={states.currentClaim !== undefined && states.currentClaim !== index}
          >
            {$i18n.get({ id: 'Claim.four_px', dm: '认领' })}
          </Button>
        );
      } else if (states.tabKey === 'P' && record?.status === 'CL' && record?.labelChangedSupported !== 'Y') {
        // 处理中&&待换标
        return (
          <Button type="primary" text onClick={() => completeChangeLabelFn(record?.consignmentNo)}>
            {$i18n.get({ id: 'CompleteBidChange', dm: '完成换标' })}
          </Button>
        );
      }
    },
    [states.currentClaim, states.tabKey],
  );

  const VasorderTime = [
    {
      label: $i18n.get({ id: 'Created.four_px', dm: '创建时间' }),
      value: 'createTime',
    },
    {
      label: $i18n.get({ id: 'CompletionTime.four_px', dm: '完成时间' }),
      value: 'completeTime',
    },
  ];

  const expordatas = () => {
    const { selectedRowKeys } = states.rowSelection;
    return Object.assign(transform(field.getValues()), { jobNos: selectedRowKeys });
  };

  useEffect(() => {
    getAllGroups().then((res) => {
      if (res && res.length) {
        res.forEach((item) => {
          item.label = item.customerGroupName;
          item.value = item.customerGroupName;
        });
      }
      console.log('resresresres', res);
      setStates({ allgroup: res });
    });
  }, []);

  return (
    <>
      <FpxPage
        header={
          <PageHeader
            title={$i18n.get({ id: 'ValueAddedOrders.four_px', dm: '增值订单' })}
            breadcrumbs={[
              { path: '', name: $i18n.get({ id: 'Order.four_px', dm: '订单' }) },
              { path: '/order/vasorder', name: $i18n.get({ id: 'ValueAddedOrders.four_px', dm: '增值订单' }) },
            ]}
          />
        }
        search={
          <>
            <Form field={field} fullWidth className="searchform">
              <Row gutter="24">
                <Col span="2p5">
                  <SearchSelect
                    selectProps={{ dataSource: VAS_ORDER, defaultValue: 'consignmentNos', name: 'input' }}
                    inputProps={{
                      style: { height: '106px' },
                      placeholder: $i18n.get({
                        id: 'MultipleQueriesAreSupportedSeparateData_4228316081.four_px',
                        dm: '支持多条查询，数据之间换行符进行分隔，最多支持100条',
                      }),
                    }}
                  />
                </Col>
                <Col span="4p5">
                  <Row gutter="24" wrap>
                    <Col span="6">
                      <Form.Item label={$i18n.get({ id: 'KHBM.CustomerCode.four_px', dm: '客户编码' })}>
                        <Input
                          placeholder={$i18n.get({ id: 'EnterTheCustomerCode.four_px', dm: '输入客户编码' })}
                          trim
                          name="customerCode"
                        />
                      </Form.Item>
                    </Col>
                    <Col span="6">
                      <Form.Item label={$i18n.get({ id: 'SkuEncoding.four_px', dm: 'SKU编码' })}>
                        <Input
                          name="skuCode"
                          placeholder={$i18n.get({ id: 'QSRSKUBM.EnterTheSkuCode.four_px', dm: '请输入SKU编码' })}
                          trim
                        />
                      </Form.Item>
                    </Col>
                    <Col span="6">
                      <Form.Item label={$i18n.get({ id: 'ServiceSegmentation.four_px', dm: '服务分段' })}>
                        <Select name="operationSegment" dataSource={VAS_OPERATE_PERIOD} defaultValue="all" hasClear />
                      </Form.Item>
                    </Col>
                    <Col span="12">
                      {/* <Form.Item label={$i18n.get({ id: 'Created.four_px', dm: '创建时间' })}>
                        <RangePicker defaultValue={[startDate, '']} showTime name="times" />
                      </Form.Item> */}
                      <SelectTime
                        selectProps={{
                          dataSource: VasorderTime,
                          defaultValue: states.defaultOrderTime,
                          name: 'timeType',
                        }}
                        rangePickerProps={{
                          showTime: true,
                          name: 'times',
                          defaultValue: states.vastime,
                        }}
                      />
                    </Col>
                    <Col span="6">
                      <Form.Item label={$i18n.get({ id: 'SkuBarcode.four_px', dm: 'SKU条码' })}>
                        <Input
                          name="skuId"
                          placeholder={$i18n.get({ id: 'QSRSKUTM.EnterTheSkuBarcode.four_px', dm: '请输入SKU条码' })}
                          trim
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row gutter="24">
                {states.showAdvancedSearch && (
                  <Col span="1p5">
                    <Form.Item label={$i18n.get({ id: 'SubspecieService.four_px', dm: '服务子类' })}>
                      <Select name="vasOrderType" dataSource={VAS_ORDER_TYPE} defaultValue="" hasClear />
                    </Form.Item>
                  </Col>
                )}

                {states.showAdvancedSearch && (
                  <Col span="1p5">
                    <Form.Item label={$i18n.get({ id: 'HandelType.four_px', dm: '处理类型' })}>
                      <Select name="operationCode" dataSource={VAS_SERVICE_OPERATE} defaultValue="" hasClear />
                    </Form.Item>
                  </Col>
                )}
                {states.showAdvancedSearch && (
                  <Col span="1p5">
                    <Form.Item label={$i18n.get({ id: 'ValueAddedServiceType.four_px', dm: '增值服务类型' })}>
                      <Select name="serviceType" dataSource={VAS_SERVICE_TYPE} defaultValue="all" hasClear />
                    </Form.Item>
                  </Col>
                )}

                {states.showAdvancedSearch && (
                  <Col span="1p5">
                    <Form.Item label={$i18n.get({ id: 'OrderSource.four_px', dm: '订单来源' })}>
                      <Select name="dataSource" dataSource={VAS_ORDER_SOUCE} defaultValue="all" hasClear />
                    </Form.Item>
                  </Col>
                )}

                {states.showAdvancedSearch && (
                  <Col span="1p5">
                    <Form.Item label={$i18n.get({ id: 'DoYouNeedToChangeThe_1163292245', dm: '是否需要换标' })}>
                      <Select name="exchangeLabelFlag" dataSource={VAS_CHANGE_LABEL_FLAG} defaultValue="" hasClear />
                    </Form.Item>
                  </Col>
                )}
              </Row>
              <Row gutter="24">
                {states.showAdvancedSearch && (
                  <Col span="1p5">
                    <Form.Item label={$i18n.get({ id: 'CustomerGroup', dm: '客户组' })}>
                      <Select name="customerGroupNames" mode="multiple" dataSource={states.allgroup} hasClear />
                    </Form.Item>
                  </Col>
                )}

                <FitScreenBox>
                  <Form.Submit type="fpx" onClick={doSubmit} validate className="fpx_search" loading={loading}>
                    {$i18n.get({ id: 'Query.four_px', dm: '查询' })}
                  </Form.Submit>
                  <Form.Reset onClick={doReset}>{$i18n.get({ id: 'Reset.four_px', dm: '重置' })}</Form.Reset>
                  <Button
                    type="normal"
                    text
                    style={{ height: '36px', marginLeft: -12 }}
                    onClick={() => {
                      setStates({ showAdvancedSearch: !states.showAdvancedSearch });
                    }}
                  >
                    <Icon type={states.showAdvancedSearch ? 'jiantou_liebiaoshouqi_o' : 'jiantou_liebiaozhankai_o'} />
                  </Button>
                </FitScreenBox>
              </Row>
            </Form>
            <div className={styles.searchfieldbtns}>
              <OfflineExport code="VALUE_ADDED_ORDER" reqObj={expordatas()} className={styles.mr16} />
              <OfflineExport
                code="VALUE_ADDED_ORDER_DETAIL"
                children="明细离线导出"
                reqObj={expordatas()}
                className={styles.mr16}
              />

              {states.tabKey === 'T' && (
                <Button type="primary" size="medium" onClick={() => batchClaim()} loading={states.claimLoading}>
                  {$i18n.get({ id: 'BulkClaim.four_px', dm: '批量认领' })}
                </Button>
              )}

              {states.tabKey === 'P' && (
                <>
                  <Button type="primary" size="medium" onClick={batchPrintSku} className={styles.mr16}>
                    {$i18n.get({ id: 'BatchPrintSkuTags.four_px', dm: '批量打印SKU标签' })}
                  </Button>
                  <Button type="primary" size="medium" onClick={batchPrint}>
                    {$i18n.get({ id: 'BatchPrintList.four_px', dm: '批量打印清单' })}
                  </Button>
                </>
              )}
              <div className={styles.tips}>
                <span>
                  {$i18n.get({ id: 'ToBeCompletedToChangeThe_1149243004', dm: '待完成换标' })}：
                  <i>{states.waitingLabelCount}</i>
                </span>
              </div>
            </div>
          </>
        }
        action={
          <ActionArea
            leftSection={<FpxTab dataSource={VAS_TASK_PERIOD_TAB} activeKey={states.tabKey} onChange={gettab} />}
            rightSection={<></>}
          />
        }
        table={
          <>
            <FpxTable
              stickyHeader
              {...tableProps}
              hasBorder={false}
              rowSelection={states.rowSelection}
              primaryKey="consignmentNo"
            >
              <Table.Column
                data-i18n-ignore-content
                title={'No.'}
                width={100}
                cell={(value: string, index: number) => index + 1}
                lock
              />
              <Table.Column
                title={$i18n.get({ id: 'ValueAddedServiceNumber.four_px', dm: '增值服务单号' })}
                dataIndex="consignmentNo"
                width={150}
                cell={gotoDetail}
              />

              <Table.Column
                title={$i18n.get({ id: 'CustomerOrderNo.four_px', dm: '客户订单号' })}
                dataIndex="refNo"
                width={240}
              />

              <Table.Column
                title={$i18n.get({ id: 'WarehouseReceiptReferenceNumber.four_px', dm: '入库单参考号' })}
                dataIndex="inboundOrder"
                width={260}
              />

              <Table.Column
                title={$i18n.get({ id: 'AssociatedNumber', dm: '关联单号' })}
                dataIndex="relativeBusinessNos"
                width={260}
                cell={(value: any) => value?.join(',')}
              />

              <Table.Column
                title={$i18n.get({ id: 'Type.four_px', dm: '类型' })}
                dataIndex="serviceType"
                width={200}
                cell={(value: string) => vToLabel(VAS_SERVICE_TYPE, value)}
              />

              <Table.Column
                title={$i18n.get({ id: 'SubspecieService.four_px', dm: '服务子类' })}
                dataIndex="vasOrderType"
                width={200}
                cell={(value: string) => vToLabel(VAS_ORDER_TYPE, value)}
              />

              <Table.Column
                title={$i18n.get({ id: 'State.four_px', dm: '状态' })}
                dataIndex="status"
                width={150}
                cell={(value: string) => vToLabel([...VAS_TASK_PERIOD, ...VAS_CHANGE_LABEL_FLAG], value)}
              />

              <Table.Column
                title={$i18n.get({ id: 'HandelType.four_px', dm: '处理类型' })}
                dataIndex="operationCode"
                width={200}
                cell={(value: string) => vToLabel(VAS_SERVICE_OPERATE, value)}
              />

              <Table.Column
                title={$i18n.get({ id: 'ServiceSegmentation.four_px', dm: '服务分段' })}
                dataIndex="operationSegment"
                width={160}
                cell={(value: string) => vToLabel([...VAS_OPERATE_PERIOD], value)}
              />

              <Table.Column
                title={$i18n.get({ id: 'TotalHoursUsed', dm: '所用总工时' }) + '(H)'}
                dataIndex="workingHour"
                width={120}
              />

              <Table.Column
                title={$i18n.get({ id: 'KHBM.CustomerCode.four_px', dm: '客户编码' })}
                dataIndex="customerCode"
                width={150}
              />

              <Table.Column
                title={$i18n.get({ id: 'Warehouse.four_px', dm: '仓库' })}
                dataIndex="warehouseCode"
                width={150}
              />

              <Table.Column
                title={$i18n.get({ id: 'Created.four_px', dm: '创建时间' })}
                dataIndex="createTime"
                width={150}
              />

              <Table.Column
                title={$i18n.get({ id: 'CompletionTime.four_px', dm: '完成时间' })}
                dataIndex="completeTime"
                width={150}
              />

              {states.tabKey === 'T' || states.tabKey === 'P' ? (
                <Table.Column
                  title={$i18n.get({ id: 'Operation.four_px', dm: '操作' })}
                  width={150}
                  lock={'right'}
                  cell={renderActionColumn}
                />
              ) : (
                <></>
              )}
            </FpxTable>
            <FpxPagination
              {...paginationProps}
              onPageSizeChange={(e) => {
                pagination.onChange(1, e);
              }}
            />
          </>
        }
      />

      <Dialog
        title={$i18n.get({ id: 'PrintProductBarcode.four_px', dm: '打印货品条码' })}
        visible={states.printBarCodevisible}
        style={{
          width: '1250px',
        }}
        height={'75%'}
        footerActions={[]}
        onClose={handlePrintCodeCancel}
        shouldUpdatePosition
      >
        <Box direction="row" align={'center'} className={styles.mb24}>
          <span className={styles.mr16}>{$i18n.get({ id: 'SkuEncoding.four_px', dm: 'SKU编码' })}：</span>
          <Search
            followTrigger
            shape="simple"
            dataSource={dealSearchData()}
            onChange={(value) => {
              onSearchChange('printSearchData', value);
            }}
            className={styles.mr16}
            hasClear
          />

          <span className={styles.mr16}>SKU ID：</span>
          <Search
            followTrigger
            shape="simple"
            dataSource={delalSkuData()}
            onChange={(value) => {
              onSearchChange('skuSearchData', value);
            }}
            className={styles.mr16}
            hasClear
          />

          <Button type="fpx" onClick={barCodeSearch} className={styles.mr16}>
            {$i18n.get({ id: 'Query.four_px', dm: '查询' })}
          </Button>
          <Button type="primary" onClick={labelPrint} className={styles.mr16} loading={states.printLoading}>
            {$i18n.get({ id: 'LabelPrinting.four_px', dm: '标签打印' })}
          </Button>
        </Box>
        <Box direction="row" align={'center'} className={styles.mb24}>
          <span className={`${styles.mr16} ${styles.printOrder}`}>
            {$i18n.get({ id: 'EntrustmentNumber.four_px', dm: '委托单号' })}：
          </span>
          <span>
            {states.rowSelection?.selectedRowKeys?.map((e, i) => {
              if (i === 0) return e;
              else return ` / ${e}`;
            })}
          </span>
        </Box>
        <Table
          hasBorder={false}
          maxBodyHeight={400}
          fixedHeader
          dataSource={states.nowPrintList}
          rowSelection={states.printRowSelection}
          primaryKey="id"
        >
          <Table.Column
            title={$i18n.get({ id: 'SerialNumber.four_px', dm: '序号' })}
            width={80}
            cell={(value: string, index: number) => index + 1}
            lock
          />

          <Table.Column
            title={$i18n.get({ id: 'EntrustmentNumber.four_px', dm: '委托单号' })}
            dataIndex="consignmentNo"
            width={180}
          />

          <Table.Column
            title={`${$i18n.get({ id: 'BeforeReplacement', dm: '更换前' })}SKU ID`}
            dataIndex="skuId"
            width={150}
          />
          <Table.Column
            title={`${$i18n.get({ id: 'AfterReplacement', dm: '更换后' })}SKU ID`}
            dataIndex="actualSkuId"
            width={150}
          />
          <Table.Column
            title={$i18n.get({ id: 'SkuCodeBeforeReplacement', dm: '更换前sku编码' })}
            dataIndex="skuCode"
            width={180}
          />
          <Table.Column
            title={$i18n.get({ id: 'SkuCodeAfterReplacement', dm: '更换后sku编码' })}
            dataIndex="actualSkuCode"
            width={180}
          />

          <Table.Column
            title={$i18n.get({ id: 'ForecastQuantity.four_px', dm: '预报数量' })}
            dataIndex="operationQty"
            width={100}
          />

          <Table.Column
            title={$i18n.get({ id: 'PrintQuantity.four_px', dm: '打印数量' })}
            dataIndex="qty"
            width={100}
            cell={(value: number, index: number, record: Record) => {
              return (
                <NumberPicker
                  style={{ width: '100%' }}
                  step={1}
                  min={0}
                  max={1000}
                  defaultValue={value}
                  onChange={(v: number) => setNewPrintList(v, index, record)}
                />
              );
            }}
          />
        </Table>
      </Dialog>
    </>
  );
};

export default VASOrder;
